export enum Role {
  FireDrillAdmin = "FireDrill.Admin",
  HandHygieneAdmin = "HandHygiene.Admin",
  EnvironmentalChecklistAdmin = "EnvironmentalChecklist.Admin",
  EnvironmentalChecklistWriter = "EnvironmentalChecklist.Writer",
  NoAccess = "NoAccess",
}
